import React from 'react';
import { motion } from 'framer-motion';
import { Quote, TrendingUp, Download } from 'lucide-react';
import { trackEvent } from '../utils/metaPixel';
const testimonials = [{
  quote: 'Subimos el CTR de 0.8% a 2.1% en 10 días.',
  author: 'Media Buyer, E-commerce',
  metric: '+162% CTR'
}, {
  quote: 'Reducimos el CPA un 37% en la primera semana.',
  author: 'Lanzador de Infoproductos',
  metric: '-37% CPA'
}];
export function TestimonialsSection() {
  return <section className="bg-fondo-warm py-16 px-4 border-t border-matrix-green/10" data-id="element-144">
      <div className="max-w-7xl mx-auto" data-id="element-145">
        <div className="text-center mb-10" data-id="element-146">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-heading text-3xl md:text-4xl font-bold text-white" data-id="element-147">
            Resultados Reales de{' '}
            <span className="text-matrix-green text-glow-green" data-id="element-148">
              Media Buyers como Vos
            </span>
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-8" data-id="element-149">
          {/* Testimonial Cards */}
          <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-8 mb-8" data-id="element-150">
            {testimonials.map((t, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.2
          }} className="bg-premium-mid p-8 rounded-2xl relative shadow-sm border border-matrix-green/20" data-id="element-151">
                <Quote className="w-10 h-10 text-matrix-green/20 absolute top-6 left-6" data-id="element-152" />
                <div className="relative z-10" data-id="element-153">
                  <p className="font-heading font-bold text-xl text-white mb-6 pt-4" data-id="element-154">
                    "{t.quote}"
                  </p>
                  <div className="flex items-center justify-between border-t border-matrix-green/10 pt-4" data-id="element-155">
                    <span className="font-body text-sm text-gray-400" data-id="element-156">
                      {t.author}
                    </span>
                    <span className="font-mono font-bold text-matrix-green bg-matrix-green/10 px-3 py-1 rounded-full text-sm" data-id="element-157">
                      {t.metric}
                    </span>
                  </div>
                </div>
              </motion.div>)}
          </div>

          {/* Case Study Box */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="bg-black rounded-2xl p-8 text-white shadow-xl relative overflow-hidden flex flex-col justify-center border border-matrix-green/30 glow-green" data-id="element-158">
            <div className="absolute -right-10 -top-10 w-40 h-40 bg-matrix-green/15 rounded-full blur-3xl" data-id="element-159" />

            <div className="flex items-center gap-3 mb-6" data-id="element-160">
              <div className="bg-matrix-green p-2 rounded-lg" data-id="element-161">
                <TrendingUp className="w-6 h-6 text-black" data-id="element-162" />
              </div>
              <h3 className="font-mono font-bold text-lg uppercase tracking-wider text-matrix-green" data-id="element-163">
                Caso de Estudio
              </h3>
            </div>

            <p className="font-heading font-bold text-2xl leading-snug mb-4" data-id="element-164">
              "Agencia en México: duplicó el ROAS en 14 días aplicando 5 ángulos
              estratégicos con PromptAdsPro."
            </p>
          </motion.div>
        </div>

        {/* WhatsApp Testimonials */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 mb-8" data-id="element-165">
          {[{
          src: 'https://i.postimg.cc/0NmZWGLd/Whastapp-1.webp',
          alt: 'Testimonio WhatsApp 1'
        }, {
          src: 'https://i.postimg.cc/RhCRZkqw/Whastapp-2.webp',
          alt: 'Testimonio WhatsApp 2'
        }].map((img, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2
        }} className="rounded-2xl overflow-hidden border border-matrix-green/20 shadow-lg" data-id="element-166">
              <img src={img.src} alt={img.alt} className="w-full h-auto object-cover" data-id="element-167" />
            </motion.div>)}
        </div>

        {/* Ads Manager Mockup Replacement */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="max-w-4xl mx-auto rounded-xl shadow-2xl overflow-hidden border border-matrix-green/30 glow-green relative" data-id="element-168">
          <div className="absolute inset-0 bg-matrix-green/5 mix-blend-overlay pointer-events-none" data-id="element-169" />
          <img src="https://i.postimg.cc/FKc2gp7M/5.webp" alt="Resultados de Ads Manager Antes y Después" className="w-full h-auto object-cover" data-id="element-170" />
        </motion.div>

        {/* CTA después de testimonios */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.8
      }} className="text-center mt-10" data-id="element-171">
          <motion.a href="https://pay.hotmart.com/I104697906M" target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('InitiateCheckout', {
          content_name: 'PromptAdsPro',
          value: 9.9,
          currency: 'USD'
        })} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-flex items-center justify-center gap-3 bg-matrix-green hover:bg-matrix-green-dark text-black font-heading font-bold text-xl py-5 px-10 rounded-xl shadow-[0_0_25px_rgba(0,255,65,0.4)] transition-all duration-300 pulse-glow" data-id="element-172">
            <Download className="w-7 h-7" data-id="element-173" />
            <span data-id="element-174">Quiero Estos Resultados</span>
          </motion.a>
        </motion.div>
      </div>
    </section>;
}